import {
  GET_OPTINS,
  GET_OPTINS_COMPLETED,
  GET_OPTINS_FAILED, SET_OPTINS, SET_OPTINS_COMPLETED, SET_OPTINS_FAILED,
  UNSUBSCRIBE,
  UNSUBSCRIBE_COMPLETED,
  UNSUBSCRIBE_FAILED,
  SUBSCRIBE,
  SUBSCRIBE_COMPLETED,
  SUBSCRIBE_FAILED
} from 'actions/unsubscribeActions'

const defaultState = {
  action: '',
  error: '',
  // get optIns
  fetchingOptIns: false,
  userId: '',
  optIns: null,
  // set optIns
  settingOptIns: false,
  settingDone: false,
  // unsubscribe
  unsubscribing: false,
  unsubscribed: false,
  // subscribe
  subscribing: false,
  subscribed: false
}

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case GET_OPTINS: {
      return {...state, fetchingOptIns: true};
    }
    case GET_OPTINS_COMPLETED: {
      return {...state, fetchingOptIns: false, optIns: {...action.payload}};
    }
    case GET_OPTINS_FAILED: {
      return {...state, fetchingOptIns: false, error: action.payload.message};
    }
    case SET_OPTINS: {
      return {...state, settingOptIns: true, settingDone: false};
    }
    case SET_OPTINS_COMPLETED: {
      return {...state, settingOptIns: false, settingDone: true};
    }
    case SET_OPTINS_FAILED: {
      return {...state, settingOptIns: false};
    }
    case UNSUBSCRIBE: {
      return {...state, unsubscribing: true, unsubscribed: false};
    }
    case UNSUBSCRIBE_COMPLETED: {
      const {unsubscribed} = action.payload;
      return {...state, unsubscribing: false, unsubscribed: unsubscribed === 'OK'};
    }
    case UNSUBSCRIBE_FAILED: {
      return {...state, unsubscribing: false};
    }
    case SUBSCRIBE: {
      return {...state, subscribing: true, subscribed: false};
    }
    case SUBSCRIBE_COMPLETED: {
      const {subscribed} = action.payload;
      return {...state, subscribing: false, subscribed: subscribed === 'OK'};
    }
    case SUBSCRIBE_FAILED: {
      return {...state, subscribing: false, error: action.payload.message};
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/unsubscribe.js